import type { LogParams } from '@application/api';
import type {
  AnimalSensitivityEnum,
  AnimalSizeEnum,
  AnimalTypeEnum,
  BirthdayType,
  CouplingType,
  DogCoat,
  DogColor,
  GenderEnum,
} from '@gql/graphql';
import type { SelectOption } from '@presentation/components';
import type { FormMode } from '@presentation/types';
import type { Dayjs } from 'dayjs';
import type { MouseEventHandler } from 'react';

export interface MtAnimalsBreederPageFormValues {
  name?: string;
  birthdayType?: BirthdayType;
  birthday?: Dayjs;
  gender?: GenderEnum;
  images?: File[] | string[] | undefined[];
  size?: AnimalSizeEnum | null;
  weight?: number | null;
  sensitivities?: AnimalSensitivityEnum[];

  passportFile?: File | string;
  type?: AnimalTypeEnum;
  dogInfo?: MtAnimalsBreederPageFormValuesDog;
  studInfo?: MtAnimalsBreederPageFormValuesStudInfo;
}

export interface MtAnimalsBreederPageFormValuesDog {
  competitionTitles?: string;
  healthTestsResults?: string;
  microshipNumber?: string;
  pedigree?: string | null;
  pedigreeNumber?: string;
  breedId?: number;
  breederIsDogOwner?: boolean;
  color?: DogColor | null;
  coat?: DogCoat | null;
}

export interface MtAnimalsBreederPageFormValuesStudInfo {
  availableForBreeding?: boolean;
  knownPrice?: boolean;
  price?: number;
  description?: string;
  champion?: boolean;
  type?: CouplingType;
  accomodation?: boolean;
  adn?: string;
}

export interface MtAnimalsBreederPageFormOptions {
  breeds: SelectOption<number>[];
}

export interface MtAnimalBreederPageData {
  mode: FormMode;
  archived?: boolean;
  onSubmitClick: MouseEventHandler;

  onEditClick?: MouseEventHandler;
  onDeleteClick?: MouseEventHandler;
  onBackClick?: MouseEventHandler;
  onCancelClick?: MouseEventHandler;
  onUnarchiveClick?: MouseEventHandler;

  disabledParentType?: boolean;

  options: MtAnimalsBreederPageFormOptions;

  loading?: boolean;
  log?: (params: LogParams) => void;
}

export interface MtAnimalBreederPageProps extends MtAnimalBreederPageData {}
